import React, { useState } from 'react';
import { Accordion, Col } from 'react-bootstrap';
import { Card, CardBody, CardHeader, Collapse } from 'reactstrap';
import { Btn, H5 } from '../../../AbstractElements';
import { Add, bgstar, CollapsibleGroupItem, ColorAccordion, ColorPara, Colorparatext } from '../../../Constant';

const PrimaryColorAccordian = () => {
  const [isOpen, setIsOpen] = useState(1);
  const toggle = (id) => (isOpen === id ? setIsOpen(null) : setIsOpen(id));
  const data = [1, 2, 3];
  return (
    <Col sm='12' xl='6'>
      <Accordion defaultActiveKey='0'>
        <Card>
          <CardHeader className='pb-0'>
            <H5>{ColorAccordion}</H5>
            <span>
              {Add} <code>{bgstar}</code> {Colorparatext}
            </span>
          </CardHeader>
          <CardBody>
            <div className='default-according' id='accordion1'>
              {data.map((accordian, i) => (
                <Card key={i}>
                  <CardHeader className='bg-primary'>
                    <H5 className='mb-0'>
                      <Btn as={Card.Header} className='btn btn-link ps-0 text-white' color='default' onClick={() => toggle(accordian)}>
                        {CollapsibleGroupItem}
                        <span className='digits'>{accordian}</span>
                      </Btn>
                    </H5>
                  </CardHeader>
                  <Collapse isOpen={isOpen === accordian}>
                    <CardBody>{ColorPara}</CardBody>
                  </Collapse>
                </Card>
              ))}
            </div>
          </CardBody>
        </Card>
      </Accordion>
    </Col>
  );
};

export default PrimaryColorAccordian;
